<template>
  <div class="fixed top-navbar">
    <div class="flex flex-center bg" :class="bgColor" >
      <slot>
        <v-btn v-if="!isHome" icon small color="white" name="arrow-left" @click="arrowLeft" >
          <v-icon>
            {{ icons.mdiArrowLeftCircle }}
          </v-icon>
        </v-btn>
        
        <div class="home-logo" v-if="isHome"><img :src="homelogo" /></div>
        <div :class="{'title':1, 'onHome':isHome}">{{ title }}</div>
      <div class="nav-right">
        
        <div class="language-wrapper">
          <ul class="language-switch">
            <li
              v-for="(item,i) in items" 
              :key="i"
              @click="changeLocale(item.text)"
              :class="[ i18n.locale===item.text ? 'active': '']"
            >
            {{ item.text}}</li>
          </ul>
        </div>

        <!-- <div class="icon-user">
          <NavUser 
            @evtDineinOrderDetail="tablesDineinOrderDetail" :is_scene_code="is_scene_code"   :order_id="order_id" />
        </div> -->

        <div class="icon-setting">
          <v-btn icon @click.stop="drawer3 = !drawer3" :disabled="!required">
            <v-icon class="whiteIcon">
              {{ icons.mdiDotsVertical}}
            </v-icon>
          </v-btn>
        </div>

        <v-navigation-drawer  v-model="drawer3" temporary right fixed :width="$vuetify.breakpoint.xs ? '480' :'396'" height="100%">
          <NavMenu @evtCloseNavMenu="closeMenu" :isLogin="isLogin" @evtToMyOrder="toMyOrder" @evtUserLogout="userLogout" @evtUserSSO="userSso" @evtUserProfile="userProfile"
            @evtDineinOrderDetail="tablesDineinOrderDetail" :required="required" :is_scene_code="is_scene_code" :order_id="order_id" />
        </v-navigation-drawer>
      </div>
      </slot>
    </div>
  </div>
</template>
<script>
import homelogo from "@/assets/logo.png"
import { 
  mdiDotsVertical,
  mdiArrowLeftCircle,
  } from '@mdi/js';
import i18n from '../../locales/index'

import { getXssoToken, ssoLogout, getSceneCodeOrder  } from "@/api/api"
import { cartMixin } from "@/mixins/cartMixin"
import { mapGetters, mapActions } from 'vuex'
import { FASTORDER_MY } from '@/constants'

export default {
  components: {
    NavMenu: () => import(/* webpackChunkName: "navMenu" */ "../../components/common/NavMenu.vue")
  },
  props: {
    title: {
      type: String,
      default: FASTORDER_MY,
    },
    bgColor: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      sso_url: "",
      is_scene_code: false,
      order_id: 0,
      isLogin: false,
      required: false, // change true to show main menu
      i18n,
        selectedItem: 0,
        items: [
        { text: 'EN' },
        { text: '中文' },
        { text: 'BM' },
        { text: '한국' },
        ],
      drawer3:false,
      group: null,
      icons: {
        mdiDotsVertical,
        mdiArrowLeftCircle,
      },
      isHome: true,
      homelogo: homelogo
    }
  },
  mounted () {
    this.queryLang()
  },
  created () {
    setTimeout(() => {
      this.getToken();
    }, 200);
    setTimeout(() => {
      this.scenecodeOrder();
    }, 300);

    if (this.$route.name !== 'home') {
      this.isHome = false
    }
    console.log('============> router-----', this.isHome)
  },
  mixins: [cartMixin],
  methods: {
    ...mapActions({
      saveCurrentLoginStatus: "user/settingLoginStatus",
      saveCurrentUserinfo: "user/settingUserInfo",
      saveCurrentXssoToken: "user/settingXssoToken",
    }),
    async getToken () {
      const actname = this.$route.query["do"];
      const queryParams = this.getUrlParams({
        do: "check_sso_token",
        actname: actname
      });
      getXssoToken("/app/index.php", queryParams)
        .then(res => {
          if (res.data) {
            const { is_login, sso_url, refresh_token, order_id, sso_user } = res.data;
            this.isLogin = is_login;
            if (is_login) {
              this.saveCurrentLoginStatus(is_login)
              this.saveCurrentUserinfo(sso_user)
              this.saveCurrentXssoToken(refresh_token)
              localStorage.removeItem("refresh_token");
              localStorage.setItem("refresh_token", refresh_token);
              this.$emit("evtIsLogin",is_login)
            }
            if (!is_login) {
              this.sso_url = sso_url;
              this.$emit("evtIsLogin",!is_login)
            }
          } else {
            // this.$toast('Invalid Tables Or QR Code, Please contact waiter for more info!!!')
            console.log('Invalid Tables Or QR Code, Please contact waiter for more info!!!');
          }
          this.required = true;
        })
        .catch(error => {
          console.log("====>[getXssoToken.error]", error);
        });
        
    },
    scenecodeOrder () {
      const actname = this.$route.query["do"];
      const queryParams = this.getUrlParams({
        do: "get_tables_scenecode_order",
        actname: actname
      });
      getSceneCodeOrder("/app/index.php", queryParams)
        .then(res => {
          const resData = res.data;
          this.is_scene_code = resData.is_scene_code;
          console.log('this.is_scene_code', this.is_scene_code);

          this.order_id = resData.order_id || 0;
        }).catch(error => { });
    },

    async userLogout () {
      const logout = await ssoLogout(
        "/app/index.php?i=2&c=entry&do=ssouserLogout&m=weisrc_dish",
        {}
      );
      this.sso_url = logout.data.sso_url;
      this.isLogin = false;
      this.$toast(logout.msg);
      this.$emit("evtLogout", { isLogin: false });
    },
    userProfile () {
      location.href = "/app/index.php?i=2&c=entry&do=usercenter&m=weisrc_dish";
    },
    toMyOrder () {
      const { i, c, m, mode, append, h5api, storeid } = this.getUrlParams({});
      const queryJson = {
        i: i,
        c: c,
        m: m,
        mode: mode,
        append: append,
        h5api: h5api,
        storeid: storeid
      };
      const url = { path: "/order/history", query: queryJson };
      console.log("url", url);
      this.$router.push(url);
    },
    userSso () {
      if (this.sso_url) {
        location.href = this.sso_url;
      }
    },
    tablesDineinOrderDetail () {
      const { i, c, m, mode, append, h5api, storeid } = this.getUrlParams({});
      const queryJson = {
        i: i,
        c: c,
        mode: mode,
        append: append,
        do: "orderdetail",
        h5api: "on",
        m: "weisrc_dish",
        storeid: storeid,
        orderid: this.order_id,
        op: "viewdetail",
        year: "2020",
        pt: "wx2h5"
      };
      //order?i=2&c=entry&do=orderdetail&h5api=on&m=weisrc_dish&orderid=557&op=viewdetail&mode=1&append=1&year=2020&pt=wx2h5
      const url = { path: "/order", query: queryJson };
      console.log("......orderdetail>", url);
      this.$router.push(url);
    },
    queryLang() {
        let urlParamsArray = window.location.hash.split("&")
        let query = this.$route.query
        if(query.lang === 'en'){
          i18n.locale = 'EN';
        }else if(query.lang === '中文'){
          i18n.locale = '中文';
        }else if(query.lang === 'bm'){
          i18n.locale = 'BM';
        }else if(query.lang === '한국'){
          i18n.locale = '한국';
        }else if(query.lang === null || query.lang === undefined){
          i18n.locale = 'EN';
          let urlParams = window.location.hash
          history.replaceState( {}, '', urlParams + `&lang=en`)
        }else{
          i18n.locale = 'EN';
          let result = urlParamsArray.filter(data => data.substring(0,4) !== "lang")
          result.push("lang=en")
          let newResult = result.join('&')
          history.replaceState( {}, '', newResult)
        }
    },
    changeLocale(locale) {
      let urlParamsArray = window.location.hash.split("&")
      i18n.locale = locale;

        const langFunction = (locale)=>{
          if( locale == 'EN'){
            return "lang=en"
          }else if(locale == '中文'){
            return "lang=中文"
          }
          else if(locale == 'BM'){
            return "lang=bm"
          }
          else if(locale == '한국'){
            return "lang=한국"
          }
        }

        let result = urlParamsArray.filter(data => data.substring(0,4) !== "lang")
        result.push(langFunction(locale))
        let newResult = result.join('&')
        history.replaceState( {}, '', newResult)

    },
    arrowLeft () {
      console.log('============> arrowLeft', '返回上一面')
      if (this.$route.name !== 'home') {
        window.history.back(-1)
      }
    },
    closeMenu(){
      this.drawer3 = !this.drawer3
    }
  }
}
</script>
<style lang="less">
@import url('../../assets/css/common.less');
.top-navbar {
  z-index: 1000;
  left: 0;
  right: 0;
  top: 0;
  color: @fff;
}

.home-logo{
  margin-left: 16px;
  max-width: 20px;
  max-height: 20px;
  margin-right: 14px;
  @media only screen and (max-width: 600px) {
    max-width: 18px;
    max-height: 18px;
    margin-left: 0px;

  }
  img{
    width: 100%;
  }
}

.bg {
  background-color: rgba(0, 0, 0, 0.5);
  padding-left: 4px;
  padding-right: 4px;
  height: 36px;
  .icon {
    font-size:16px ;
    padding: 5px;
    background-color: rgba(255, 255, 255, 0.38);
    border-radius: 100%;
    margin-right: 13px;
    @media only screen and (max-width: 480px) {
        font-size: 14px;
        padding: 3px;
    }
  }
  .title {
    padding: 2px 0;
    font-weight: 700;
    width:100% !important;
    
    @media only screen and (max-width: 992px) {
      font-size: 18px !important;
    }
    @media only screen and (max-width: 600px) {
      font-size: 16px !important;
    }
    @media only screen and (max-width: 320px) {
      font-size: 15px !important;
    }
  }
  .onHome {
    width: 100%;
    text-align: center;
    @media only screen and (max-width: 768px) {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}

.nav-right{
  display: flex;
  align-items: center;
}

.language-wrapper{
  @media only screen and (max-width: 768px) {
    display: none;
  }

  .icon-setting{
    
    @media only screen and (min-width: 769px) {
        font-size: 12px;
    }
  }

}

.language-switch{
  display: flex;
  align-items: center;
  font-size: 13px;
  margin: 0 5px;
  .active{
    font-weight: bold;
    box-shadow: 0 0 1px 0px rgb(43, 43, 43);
  }
  li{
    min-width: 42px !important;
    text-align: center;
    padding: 0 7px;
    transition: all .3s ease-in-out;
    border-right: 1px solid grey;
  }
  li:hover{
    cursor: pointer;
    background: green;
  }
  li:active{
    cursor: pointer;
    background: rgb(1, 83, 45);
    transition: all .3s ease-in-out;
  }
  li:nth-child(4){
    width: 40px;
    border-right: 0px solid grey;
  }

}



</style>
